/**
 * Always-available IT support entry for HUB sidebar and land page.
 */

export const HUB_SUPPORT_APP = {
  id: 'it_support',
  name: 'IT Technical Support',
  description:
    'Request help with Google Workspace, email, passwords, permissions, HUB apps, devices, or other IT issues',
  path: '/hub/support',
}
